import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  OnDestroy,
} from '@angular/core';
import { FiscalYear } from '@ops/shared-types';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ops-fiscal-year',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './ops-fiscal-year.component.html',
  styleUrl: './ops-fiscal-year.component.scss',
})
export class OpsFiscalYearComponent implements OnDestroy {
  _projectStatus = { id: 0, name: '' };
  @Input() selectedYear: string;

  @Input() set isPreviewMode(val: boolean){
    this.isForcedPreview = val;
  };

  @Input() set fiscalYearList(val: FiscalYear[]) {
    this._fiscalYearList = val;
    this.refreshSelectedYearValue();
  }

  @Input() set selectedStatus(val: string) {
    const matchStatus = this.statusOptions.find((so) => so.id === +val);

    this._projectStatus = matchStatus ?? this.statusOptions[0];
    // if() {
    this.isPreview = !!(
      this._projectStatus.id == 2 || this._projectStatus.id == 3
    );
    // }
  }

  get selectedStatus() {
    return this._projectStatus?.name ?? '';
  }

  get selectedStatusId() {
    return this._projectStatus.id;
  }

  isPreview: boolean = false;

  isForcedPreview: boolean = false;

  _fiscalYearList: FiscalYear[] = [];

  selectedYearValue: string = '';


  @Output() yearChanged: EventEmitter<string> = new EventEmitter<string>();

  isExpanded = 0;

  closeTimeout: any = null;
  mouseLeft = false;
  mouseEnter = false;

  statusOptions = [
    {
      id: 0,
      name: 'Pitching',
    },
    {
      id: 1,
      name: 'Ongoing',
    },
    {
      id: 2,
      name: 'Completed',
    },
    {
      id: 3,
      name: 'Submitted',
    },
    {
      id: 4,
      name: 'Cancelled',
    },
  ];

  private languageSubscription: Subscription;

  constructor(
    private elementRef: ElementRef,
    private translateService: TranslateService
  ) {
    this.isExpanded = 0;
    this.updateStatusNames();
    
    // Subscribe to language changes
    this.languageSubscription = this.translateService.onLangChange.subscribe(() => {
      this.updateStatusNames();
    });
  }

  ngOnDestroy() {
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
  }

  private updateStatusNames() {
    this.statusOptions = [
      {
        id: 0,
        name: this.translateService.instant('Pitching'),
      },
      {
        id: 1,
        name: this.translateService.instant('Ongoing'),
      },
      {
        id: 2,
        name: this.translateService.instant('Completed'),
      },
      {
        id: 3,
        name: this.translateService.instant('Submitted'),
      },
      {
        id: 4,
        name: this.translateService.instant('Cancelled'),
      },
    ];

    // Update the current status name if it exists
    if (this._projectStatus.id >= 0) {
      const currentStatus = this.statusOptions.find(so => so.id === this._projectStatus.id);
      if (currentStatus) {
        this._projectStatus.name = currentStatus.name;
      }
    }
  }

  toggleSort() {
    if (this.isExpanded === 1) {
      this.isExpanded = 2;
    } else if (this.isExpanded === 2) {
      this.isExpanded = 1;
    } else if (this.isExpanded === 0) {
      this.isExpanded = 1;
    }
  }

  selectOption(optionId: string) {
    // this.selectedStatus = '' + optionId;
    
    this.isExpanded = 0;
    this.yearChanged.emit(optionId);
    this.selectedYear = optionId;
    this.refreshSelectedYearValue();
  }
  startCloseTimeout(waitingTime?: number) {
    clearTimeout(this.closeTimeout);

    const wTime = waitingTime || 1000;

    if (this.isExpanded) {
      this.closeTimeout = setTimeout(() => {
        this.isExpanded = 2;
      }, wTime);
    }
  }

  refreshSelectedYearValue() {
    const matchStatus = this._fiscalYearList.find(
      (so) => so._id === this.selectedYear
    );

    const res = this.translateService.instant('fiscalYear.fy') + ' ' + matchStatus?.yearNumber;

    this.selectedYearValue = matchStatus ? res : this.translateService.instant('CurrentFY');
  }

  // Cancel close timeout if hovered
  @HostListener('mouseenter')
  onMouseEnter() {
    this.mouseLeft = false;
    this.mouseEnter = true;
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
    }
  }

  // Handle blur and close dropdown after a timeout
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      clearTimeout(this.closeTimeout);
      if (this.isExpanded === 1) {
        this.isExpanded = 2;
      }
    }
  }

  // Reset close timeout if user hovers back
  @HostListener('mouseleave')
  onMouseLeave() {
    this.mouseLeft = true;
    this.startCloseTimeout();
  }
}
